import React from "react";
import reviewer1 from "@assets/images/reviews/reviewer1.jpg";
import reviewer2 from "@assets/images/reviews/reviewer2.jpg";
import reviewer3 from "@assets/images/reviews/reviewer3.jpg";
import reviewer4 from "@assets/images/reviews/reviewer4.jpg";
import reviewer5 from "@assets/images/reviews/reviewer5.jpg";

/**
 * 5 overlapping real reviewer avatars beside the 5.0 star rating.
 * The left avatars overlap over the right ones with decreasing z-index.
 */
const REVIEWERS = [
  { id: 1, src: reviewer1, alt: "Reviewer 1" },
  { id: 2, src: reviewer2, alt: "Reviewer 2" },
  { id: 3, src: reviewer3, alt: "Reviewer 3" },
  { id: 4, src: reviewer4, alt: "Reviewer 4" },
  { id: 5, src: reviewer5, alt: "Reviewer 5" },
];

const ReviewerFaces = () => (
  <span className="auth-media-faces" aria-label="Customer reviews">
    { REVIEWERS.map((reviewer, index) => (
      <img
        key={ reviewer.id }
        src={ reviewer.src }
        alt={ reviewer.alt }
        className="auth-media-face"
        style={ { zIndex: REVIEWERS.length - index } }
      />
    )) }
  </span>
);

export default ReviewerFaces;
